import React, { useEffect, useState } from "react";
import "./DeleteUserModal.css";
import { RootState } from "../../redux/type";
import Button from "../UI/Button";
import { useDispatch, } from "react-redux";
import { deleteUserInDatabase } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import "firebase/firestore";

interface IModal {
    setOpenModal: (isOpen: boolean) => void;
    userId : string
  }
  

const Modal = ({ setOpenModal, userId} : IModal) =>{
    const dispatch= useDispatch();
    // const [data, setData] = useState<IMessage | null>(null);

    // useEffect(() => {
    //     if (user) {
    //       setData(message);
    //     }
    //   }, []);
      
    // if (!message) {
    //     return null;
    //   }
    // const { description, type } = data || {};

    // const getUpdatedMessages = (e : any)=>{
    //   const updatedAt = new Date().getTime()
    //   setData((data) => ({
    //     ...data!,
    //     [e.target.name]: e.target.value,
    //     updatedAt : updatedAt,
    //   }));
    // }
    console.log("in delete modal", userId)
    const updatedUserStatusInDB=(e :any )=>{
      e.preventDefault()
          dispatch(deleteUserInDatabase(userId));
          setOpenModal(false)
    }

    return (
    <div className="modalBackground">
      <div className="modalContainer">
        {/* <div className="titleCloseBtn">
        </div> */}
        <div className="title">
          <h1>Delete User </h1>

          {/* <button className="titleCloseBtn"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            X
          </button> */}

        </div>
        <div className="body py-2">
            <div className="col-md-12">
                <form onSubmit={updatedUserStatusInDB}>
                    {/* <div className="form-row">
                      <select className="form-control" name="type" placeholder="Click here to enter your message type" value={type || ""} onChange={getUpdatedMessages}>
                        <option value="">Click here to select your message type</option>
                        <option value="high">High</option>
                        <option value="low">Low</option>
                      </select>
                    </div> */}
                    {/* <div className="form-row">
                        <input type="text" className="form-control" onChange={getUpdatedMessages} name="title" placeholder="Title" value={title || "" }  />
                    </div> */}
                    {/* <div className="form-row">
                        <textarea className="form-control" onChange={getUpdatedMessages} name = "description" value={description || ""} style={{lineHeight: "normal", padding:"1.5%"}} id="" placeholder="Add your message"></textarea>
                    </div>  */}
                    <h2 className="py-2">Are you sure want to delete this user?</h2>
                    <div className="footer">
                        <Button type="submit" text="Yes" className="btn btn-danger"/>
                        <Button text="No" className="btn btn-primary" onClick={() => {setOpenModal(false)}}/>
                      </div>                                 
                </form>
            </div>
        </div>
        
      </div>
    </div>
  );
}

export default Modal;
